<template>
  <button
    v-on-click-outside="() => (dropdownOpen = false)"
    class="relative h-10 min-w-max rounded-sm bg-primary bg-linear-to-bl from-primary-button-1 to-primary-button-2 shadow-primary-button transition-colors hover:to-primary-button-hover-2"
    :class="{
      'cursor-not-allowed': disabled,
    }"
    data-cy="primary-button-with-dropdown"
    :disabled="disabled"
    @click="emit('button:click')"
  >
    <div class="flex items-center justify-between pr-12 pl-3">
      <div class="flex space-x-2 font-semibold text-white">
        <slot name="button" />
      </div>
      <div
        class="absolute right-0 flex h-10 w-10 cursor-pointer items-center justify-center rounded-r"
        data-cy="dropdown-button-toggle"
        :class="{
          'bg-blue-400!': dropdownDisabled,
          'cursor-default!': dropdownDisabled,
          'bg-primary': !dropdownOpen,
          'bg-blue-800': dropdownOpen,
        }"
        @click.stop="toggleDropdown"
      >
        <dropdown-chevron
          class="-mt-0 -mr-0 cursor-pointer"
          :class="{ 'cursor-default!': dropdownDisabled }"
          data-cy="dropdown-options-chevron"
          :is-open="dropdownOpen"
          :is-default-position="false"
          fill="white"
        />
      </div>
    </div>
    <ul v-if="dropdownOpen" class="action-menu-dd top-full right-0 mt-2">
      <action-menu-item
        v-for="item in dropdownItems"
        :key="item.label"
        @click.stop="handleActionMenuItemClick(item.handler)"
      >
        <component
          :is="item.componentData.component"
          v-if="item.componentData"
          v-bind="item.componentData.props"
          @change="item.handler"
        >
          <span :data-cy="`dropdown-item--${item.label}`">
            {{ item.label }}
          </span>
        </component>
        <div v-else class="flex items-center space-x-2">
          <icon-base v-if="item.icon" :icon="item.icon" class="mr-2" />
          <span>{{ item.label }}</span>
        </div>
      </action-menu-item>
    </ul>
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";

import ActionMenuItem from "@/components/ui/ActionMenuItem.vue";
import DropdownChevron from "@/components/ui/DropdownChevron.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { IDropdownItem } from "@/models/common";

const emit = defineEmits<{
  "button:click": [];
}>();

const { disabled, dropdownDisabled, dropdownItems } = defineProps<{
  disabled?: boolean;
  dropdownDisabled?: boolean;
  dropdownItems: IDropdownItem[];
}>();

const dropdownOpen = ref(false);

const handleActionMenuItemClick = (callback: () => void) => {
  dropdownOpen.value = false;
  callback();
};

const toggleDropdown = () => {
  if (dropdownDisabled) {
    return;
  }

  dropdownOpen.value = !dropdownOpen.value;
};

defineExpose({
  dropdownOpen,
});
</script>
